import { useStores } from '../stores/store';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Loader from './common/loader';

function PasswordRecovery1Page(props) {
	const { t } = useTranslation();
	const { auth } = useStores();
	const [error, setError] = useState<string>("");
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [isEmailSent, setIsEmailSent] = useState<boolean>(false);
	const { register, handleSubmit, formState: { errors } } = useForm();
	let navigate = useNavigate();

	const emailValidation = email => {
		return (
			email.indexOf('@') !== -1 &&
			email.trim().length >= 3 &&
			email.substring(email.indexOf('@'), email.length).indexOf('.') !== -1
		);
	};

	const onSubmit = async data => {
		if (!emailValidation(data.email)) {
			setError("E-mail non valida");
			return;
		}

		setIsLoading(true);

		auth.sendOTP(data.email).then((res) => {
			if (!res || res.error || !res.success) {
				setIsLoading(false);
				setError(res.msg);
			} else {
				setIsEmailSent(true);
			}
		});
	};

	const back = (evt) => {
		navigate(`/login`);
	};

	return (
		<div className="grid h-screen place-items-center">
			{ !isEmailSent ?
				<div className="w-full flex flex-col items-center justify-center">
					<form className="border-2 border-primary p-2 rounded-2xl flex flex-col items-center justify-center" onSubmit={handleSubmit(onSubmit)}>
						<label>{t('email')}</label>
						<input {...register("email", { required: true })} className="form-control mt-1 bg-primary-light rounded-lg p-1 outline-2 outline-primary" />
						{errors.emailRequired && <span>{t('fieldMandatory')}</span>}

						<button type="submit" className="bg-primary text-white text-center rounded-lg p-2 mt-4">
							{t('send')}
						</button>
					</form>

					{ error && error.length > 0 &&
						(
							<span className="text-primary mt-4">{error}</span>
						)
					}
					{ isLoading &&
						(
							<Loader />
						)
					}
					<button onClick={back} className="border-2 border-primary text-primary text-center rounded-lg p-2 mt-2 uppercase">
						{t('cancel')}
					</button>
				</div> : <div className='flex flex-col'>
					<span>{t('passwordResetSent')}</span>
					<button onClick={back} className="bg-primary text-white text-center rounded-lg p-2 mt-4">
						{t('back')}
					</button>
				</div>
			}
		</div>
	)
}

export default PasswordRecovery1Page;